import React from 'react';

const MeetingPreview = () => {
  return (
    <>
      <div className="signaturetoppreview">
        <span className="dangerColor"></span>
        <span className="infoColor"></span>
        <span className="successColor"></span>
      </div>
    </>
  );
};

export default MeetingPreview;
